import { create } from 'zustand';
// Import UI slices
import { createModalsSlice } from './ui/modalsSlice.js';
import { createSidebarSlice } from './ui/sidebarSlice.js';
import { createThemeSlice } from './ui/themeSlice.js';
// Import User slices
import { createAuthSlice } from './user/authSlice.js';
import { createPreferencesSlice } from './user/preferencesSlice.js';
import { createProfileSlice } from './user/profileSlice.js';
import { createMfaSlice } from './user/mfaSlice.js';
import { createTenantClubSlice } from './user/tenantClubSlice.js';
import { createCrmTenantSlice } from './user/crmTenantSlice.js';
// Create Zustand store with all slices
export const useGlobalStore = create()((...setGet) => ({
    ...createSidebarSlice(...setGet), // Sidebar state
    ...createThemeSlice(...setGet), // Theme state
    ...createModalsSlice(...setGet), // Modals state
    ...createAuthSlice(...setGet), // Authentication state
    ...createPreferencesSlice(...setGet), // Preferences state
    ...createProfileSlice(...setGet), // Profile state
    ...createMfaSlice(...setGet), // MFA enrollment state
    ...createTenantClubSlice(...setGet), // SCL tenant/club context (ADR-0004)
    ...createCrmTenantSlice(...setGet), // CRM tenant context (ADR-0004)
}));
//# sourceMappingURL=store.js.map